"use client";
import { CardTitle, Progress, ProgressBar } from '@develos/next-components';
import React from 'react';
import { AxleDataType, VehicleRecordDetailsType } from '@/types';

type Props = {
  details: VehicleRecordDetailsType;
}

const AxesDistanceContainer = ({ details }: Props) => {
  
  const variants = ['success', 'warning', 'danger', 'info'];
  const axelsDistances = (): number[] => {
    if (details === null) {
      return [];
    }
    const distances: number[] = [];
    details.axleWeightsList.forEach((element: AxleDataType) => {
      if (element.nextAxleDist !== 0) {
        distances.push(element.nextAxleDist);
      }
    });
    return distances;
  }
  
  const axelsWeights = (): number[] => {
    if (details == null) {
      return [];
    }
    return details.axleWeightsList.filter((x) => x.axleWeight > 0).map((x) => x.axleWeight);
  }

  const sumWDists = ()  => {
    if (axelsDistances().length === 0) {
      return 0;
    }
    let sum = 0;
    axelsDistances().forEach((element) => {
        sum += element;
    });
    return sum / 100;
  }

  const calcMarginLeftForAxle = (index: number): React.CSSProperties => {
    const axlesDistances = axelsDistances();
    const sumWists = sumWDists();
    if (axlesDistances.length === 0) {
      return {};
    }
    let sum = 0;
    for (let i = 0; i < index; i++) {
        sum += axlesDistances[i];
    }
    sum = ((sum) / (sumWists * 100)) * 100;
    const position = (index !== 0 && index !== axlesDistances.length) ? `calc(${sum.toFixed(2)}% - 24px)` : `${sum.toFixed(2)}%`;
    if(index === axlesDistances.length)
    {
      return { right: 0};  
    }
    return { left: position };
  }

  return (
    <div>
      <CardTitle title="Odległości"/>
      <div className="rm-row rm-mt-1">
        <div className='rm-w-full full-width'>
          <Progress >
            {axelsDistances().map((axel, index) => (
              <ProgressBar key={`progressbar${index}`} max={sumWDists()} value={axel/100} variant={variants[index % 4] as any} displayValue={`${(axel/100).toFixed(2)} m`} showValue={true}/>
            ))}
          </Progress>
        </div>
        <div className="rm-relative rm-mt-2">
          {axelsWeights().map((elem, index) => {
            return <p className='rm-absolute rm-text-xs'
                      style={calcMarginLeftForAxle(index)}
                      key={`axellabel${index}`}>
                      {elem} kg
                    </p>;
          })}
        </div>
      </div>
    </div>
  );
};

export default AxesDistanceContainer;